import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

export const useActionsByService = (serviceUid) => {
    return useQuery({
        queryKey: ['actions', { serviceUid }],
        queryFn: async () => {
            return await api.getActionsByService(serviceUid);
        },
        enabled: !!serviceUid,
    });
};

export const useCreateAction = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ serviceUid, data }) => api.createAction(serviceUid, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['actions'] });
        },
    });
};

export const useUpdateAction = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ uid, data }) => api.updateAction(uid, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['actions'] });
        },
    });
};

export const useDeleteAction = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ uid }) => api.deleteAction(uid),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['actions'] });
        },
    });
};

export const useActionRuns = (actionUid) => {
    return useQuery({
        queryKey: ['action-runs', { actionUid }],
        queryFn: async () => {
            return await api.getActionRuns(actionUid);
        },
        enabled: !!actionUid,
    });
};
